import React from 'react';
import MessageHistoryTable from 'Components/MessageHistory/MessageHistoryTable';

const MessageHistory = () => {
    return (
        <React.Fragment>
            <MessageHistoryTable />
        </React.Fragment>
    );
};

export default MessageHistory;
